import { defineFcm } from '../shared/factory';

export const FCM_PSF_PROMOTE_OR_SHARE_SHARE_SLIDE_UP_ENABLED = defineFcm('psf_promote_or_share_share_slide_up_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig();
